import React from 'react';
import EditIncomeForm from './EditIncomeForm';

export default class EditIncomeFormContainer extends React.Component {
    state = {
        income_type: this.props.income && this.props.income.income_type,
        category: this.props.income && this.props.income.category,
        income: (this.props.income && this.props.income.income) || '',
        seniority: this.props.income && this.props.income.seniority,
        starting_date: this.props.income && this.props.income.starting_date || null,
        loading: false,
        errors: {},
        hasChanged: false,
        initialValues: this.props.income,
        justify_incomes: this.props.income && this.props.income.justify_incomes,
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.income !== prevState.initialValues) {
            return {
                ...nextProps.income,
                initialValues: nextProps.income,
            };
        }
        return null;
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.name === 'income' ? e.target.rawValue : e.target.value,
            hasChanged: true,
        });
    } 

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({
            errors: {},
            loading: true,
        })
        this.props.editIncome(this.props.match.params.id, this.state)
            .then(this.closeModal)
            .catch(({ response }) =>  {
                const errors = {};
                Object.keys(response.data).forEach(field => { 
                    errors[field] = response.data[field].map(error => <span key={error}>{error}<br/></span>)
                });
                this.setState({
                    errors,
                    loading: false,
                });
            }); 
    }

    closeModal = () => {
        this.props.history.push(this.props.redirectUrl);
    }

    render() {
        const {is_staff} = this.props;
        return (
            <EditIncomeForm 
                handleChange={this.handleChange}
                handleSubmit={this.handleSubmit}
                closeModal={this.closeModal}
                is_staff={is_staff}
                {...this.state}
            />
        );
    }
}
